export default {
  baseLayer: 'BASE_LAYER',
  layerContainer: 'LAYERS_CONTAINER',
  tools: 'TOOLS',
}
